import { Injectable } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';

export type LoadingState = {
  loading: boolean;
  callers: number;
};

const initialState: LoadingState = {
  loading: false,
  callers: 0,
};

@Injectable({
  providedIn: 'root',
})
export class LoadingStore extends signalStore(
  { providedIn: 'root' },
  withState<LoadingState>(initialState),
  withMethods(store => ({
    setLoading: () => {
      patchState(store, state => {
        const callers = state.callers + 1;
        return {
          callers,
          loading: callers > 0,
        };
      });
    },
    unsetLoading: () => {
      patchState(store, state => {
        const callers = Math.max(0, state.callers - 1);
        return {
          callers,
          loading: callers > 0,
        };
      });
    },
  }))
) {}
